import { mypage_api_config, queryParam } from "utils/APIConfig";
import { ACTION_GET } from "utils/AxiosActions";

// ログイン中ユーザー本人の品質保証書（対象ユーザーはサーバー側でトークンから決まる）
export const Get_Warranties = async (page, number) => {
    const _conf = await mypage_api_config();
    const url = `${_conf.endpoints.guarantee_cards_url}?${queryParam({
        page: page,
        size: number
    })}`;
    return ACTION_GET(url, _conf.config);
}
